/// <reference path="../../app.d.ts"/>
/// <reference path="../../../../../shared/models/generated/MitgliedschaftEmpfehlungsdatenResponseApi.d.ts"/>

import { AdvertisingConsentModel } from '../../../../../shared/models/view/AdvertisingConsent';
import { BasicPersistenceService } from '../../../../../shared/services/BasicPersistenceService';
import { CcmConfiguratorModel } from '../../../../../shared/models/api/CcmConfiguratorModel';
import { SessionStorageKeys } from '../Constants';
import { AppApplicationModel } from '../models/AppApplicationModel';
import { AppApplicationModel as FdlApplicationModel } from '../../../../fdl/creditcardmodularsolarisbank/src/models/AppApplicationModel';
import { AppFormModel } from '../models/AppFormModel';

export class AppPersistenceService extends BasicPersistenceService<MglModularSystemV2AppDefinition> {

	public applicationProductSessionKey: string;

	constructor(options: MglModularSystemV2AppOptions) {
		super(options);
		this.applicationSessionKey = "application.mgl";
		this.applicationProductSessionKey = "application.init";
	}

	public setFormModelToStore(model: AppFormModel): void {
		const appModel = this.getApplicationModel();
		appModel.FormModel = model;
		this.setApplicationModel(appModel);
	}

	public getFormModelFromStore(): AppFormModel {
		const appModel = this.getApplicationModel();
		return appModel.FormModel || new AppFormModel();
	}

	/**
	 * Set the advertising consent model to sessionstorage
	 */
	public setAdvertisingConsent(advertisingConsentModel: AdvertisingConsentModel): void {
		T.Utils.Store.set(BasicPersistenceService.DEFAULT_ADVERTISING_CONSENT_SESSION_KEYPREFIX, advertisingConsentModel, T.Utils.Store.VARIABLE);
	}

	/**
	 * need default value because PersistenceService require this signature
	 */
	public getAdvertisingConsent(): AdvertisingConsentModel {
		return AdvertisingConsentModel.createFromObject(T.Utils.Store.get(BasicPersistenceService.DEFAULT_ADVERTISING_CONSENT_SESSION_KEYPREFIX, T.Utils.Store.VARIABLE));
	}

	public getApplicationModel(): AppApplicationModel {
		const dataObject = this.getApplicationObject();
		return AppApplicationModel.createFromObject(dataObject);
	}

	public getFriendsAdvertisingDataFromStorage(): MglPartnerAdvertising {
		return {
			productActive: T.Utils.Store.get('productActive', T.Utils.Store.SESSION),
			productActiveCopayment: T.Utils.Store.get('productActiveCopayment', T.Utils.Store.SESSION),
			productActiveImage: T.Utils.Store.get('productActiveImage', T.Utils.Store.SESSION),
			productOverviewUrl: T.Utils.Store.get('productOverviewUrl', T.Utils.Store.SESSION),
			productActiveTitle: T.Utils.Store.get('productActiveTitle', T.Utils.Store.SESSION),
			productActiveOrderNumber: T.Utils.Store.get('productActiveOrderNumber', T.Utils.Store.SESSION),
			productActiveModel: T.Utils.Store.get('productActiveModel', T.Utils.Store.SESSION),
			productIsCashItem: T.Utils.Store.get('productIsCashItem', T.Utils.Store.SESSION),
			productLoginUser: T.Utils.Store.get('productLoginUser', T.Utils.Store.SESSION),
			productlist: T.Utils.Store.get('productlist', T.Utils.Store.SESSION)
		};
	}

	public hasCopayment(): boolean {
		const product = this.getFriendsAdvertisingDataFromStorage();
		return !!product.productActiveCopayment && product.productActiveCopayment !== '';
	}

	public getUserMglNoFromStore(): string {
		const userData = T.Utils.Store.get('Application.Identity', T.Utils.Store.SESSION);
		return userData.MglNo;
	}

	public getIdentifyingPersonalData(): { [key: string]: any } {
		const mglApp = this.getApplicationModel();
		return {
			vorname: mglApp.FormModel.Antragssteller.Vorname,
			nachname: mglApp.FormModel.Antragssteller.Nachname,
			strasse: mglApp.FormModel.Antragssteller.Adresse.StrasseHausnummer,
			ort: mglApp.FormModel.Antragssteller.Adresse.Ort,
			plz: mglApp.FormModel.Antragssteller.Adresse.Postleitzahl
		};
	}

	public getRecommendationData(): EmpfehlungsdatenResponseApi {
		return T.Utils.Store.get(SessionStorageKeys.RecommendationData, T.Utils.Store.SESSION) as EmpfehlungsdatenResponseApi;
	}

	public setRecommendationData(data: EmpfehlungsdatenResponseApi): void {
		T.Utils.Store.set(SessionStorageKeys.RecommendationData, data, T.Utils.Store.SESSION);
	}

	public clearApplicationSession(): void {
		super.clearApplicationSession();
		T.Utils.Store.set(SessionStorageKeys.RecommendationData, null, T.Utils.Store.SESSION);
	}

	public getCreditCardPackageDataFromStore(): CcmConfiguratorModel {
		const dataObject = T.Utils.Store.get(SessionStorageKeys.CreditCardPackageData, T.Utils.Store.SESSION);
		return CcmConfiguratorModel.createFromObject(dataObject);
	}

	public getFdlApplication(): FdlApplicationModel {
		const dataObject = T.Utils.Store.get(this.applicationProductSessionKey, T.Utils.Store.SESSION);
		return FdlApplicationModel.createFromObject(dataObject);
	}

	public getExternalProductKey(): string {
		const data = this.getFdlApplication();
		return data.CalculatorModel.ProductKey;
	}
}
